import './style.css';
import { Box, styled } from '@mui/material';

const Overlay = styled(Box)(({ theme }) => ({
  position: "fixed",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 31,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent background
}));


const Spinner = () => {
  return (<Overlay>
    <Box className='loader'></Box>;
  </Overlay>)


};

export default Spinner;
